import React, { useRef } from 'react'
import o from '../../components/Overlay.module.css'
import styles from './Labels.module.css'
import { useLayer } from '../../components/layers'
import { PendingButton } from '../../components/pending'

// Above the large-batch threshold Generate asks first (§7m.5, h 4714-4720):
// the count, that it is committed as one batch and rendered in the
// background, and that the identities cannot be reused if the paper is
// thrown away. The server refuses a large Generate without this, so the
// dialog is the only way through, not a courtesy.
export function LargeBatchConfirm({
  labels,
  threshold,
  busy,
  onConfirm,
  onClose,
}: {
  labels: number
  threshold: number
  busy: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  const el = useRef<HTMLDivElement>(null)
  const { requestClose, confirm } = useLayer(true, onClose, { el, modal: true, busy })
  const n = labels.toLocaleString('en-NZ')
  return (
    <div className={o.scrim} onClick={requestClose}>
      <div ref={el} className={[o.modal, o.narrow].join(' ')} role="alertdialog" aria-modal="true" aria-label={`Generate ${n} labels?`} onClick={(e) => e.stopPropagation()}>
        <div className={o.head}>
          <div className={o.headText}>
            <h2 className={o.title}>Generate {n} labels?</h2>
          </div>
          <button type="button" className={o.close} aria-label="Close" disabled={busy} onClick={requestClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25">
              <path d="M18 6 6 18M6 6l12 12" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className={o.body}>
          <p style={{ margin: 0, fontSize: '0.8438rem', lineHeight: 1.6, color: 'var(--dp-ink2)' }}>
            That is above the {threshold.toLocaleString('en-NZ')} label operational threshold, so it needs a second look. {n} identities will be committed in
            one batch and rendered in the background: the batch is never split into separately numbered batches, and the identities cannot be reused if
            you throw the paper away.
          </p>
          <p style={{ margin: 0, fontSize: '0.75rem', lineHeight: 1.5, color: 'var(--dp-muted)', marginTop: '0.75rem' }}>You can keep working while it renders. The batch appears in Print history, and Background tasks says when it is ready.</p>
        </div>
        <div className={o.foot}>
          <button type="button" className={o.ghost} disabled={busy} onClick={requestClose}>
            Go back
          </button>
          <PendingButton className={o.primary} busy={busy} pending="Committing…" onClick={onConfirm}>
            Commit and render
          </PendingButton>
        </div>
      </div>
      {confirm}
    </div>
  )
}
